import { useState } from "react";
import { Shield, Menu, X, ExternalLink, ChevronDown } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const navCategories = [
  {
    label: "Guías Urgentes",
    emoji: "🚨",
    items: [
      { label: "¿Qué es el SR-22?", href: "/que-es-sr22" },
      { label: "SR-22 después de un DUI", href: "/sr22-despues-de-dui" },
      { label: "SR-22 instantáneo en 15 min", href: "/sr22-electronico-instantaneo" },
      { label: "Formulario SR-26 — ¡Peligro!", href: "/formulario-sr26" },
      { label: "Accidente sin seguro", href: "/accidente-sin-seguro" },
      { label: "Verificar licencia y SR-22", href: "/verificar-licencia-sr22" },
      { label: "🔒 SR-22 y tu Trabajo", href: "/sr22-trabajo-empleador" },
    ],
  },
  {
    label: "Por Estado",
    emoji: "📍",
    items: [
      { label: "SR-22 en Florida (FR-44)", href: "/sr22-florida" },
      { label: "Affidavit y Master File (FL)", href: "/affidavit-master-file-florida" },
      { label: "SR-22 en California", href: "/sr22-california" },
      { label: "SR-22 en Texas", href: "/sr22-texas" },
      { label: "SR-22 en Illinois / Chicago", href: "/sr22-illinois" },
      { label: "SR-22 en Arizona", href: "/sr22-arizona" },
      { label: "SR-22 en Nevada / Las Vegas", href: "/sr22-nevada" },
      { label: "SR-22 en Colorado / Denver", href: "/sr22-colorado" },
      { label: "SR-22 en Georgia / Atlanta", href: "/sr22-georgia" },
      { label: "SR-22 en New Jersey (Surcharges)", href: "/sr22-new-jersey" },
      { label: "SR-22 en New York (FS-1)", href: "/sr22-new-york" },
      { label: "SR-22 en Washington", href: "/sr22-washington" },
      { label: "SR-22 en North Carolina (DL-123)", href: "/sr22-north-carolina" },
      { label: "SR-22 en Connecticut", href: "/sr22-connecticut" },
      { label: "SR-22 en Oregon (DUII)", href: "/sr22-oregon" },
      { label: "SR-22 en Maryland (MVA)", href: "/sr22-maryland" },
      { label: "SR-22 en Indiana (BMV)", href: "/sr22-indiana" },
      { label: "Seguro alto riesgo Massachusetts (SDIP)", href: "/sr22-massachusetts" },
      { label: "SR-22 en Pennsylvania (PennDOT)", href: "/sr22-pennsylvania" },
      { label: "SR-22 en Wisconsin (OWI)", href: "/sr22-wisconsin" },
      { label: "SR-22 / FR-44 en Virginia", href: "/sr22-virginia" },
    ],
  },
  {
    label: "Tipos y Casos",
    emoji: "📋",
    items: [
      { label: "SR-22 Non-Owner", href: "/seguro-sr22-non-owner" },
      { label: "⚠️ Trampa del Non-Owner (Roommate)", href: "/trampa-seguro-non-owner-roommate" },
      { label: "SR-22 para motos", href: "/sr22-para-motos" },
      { label: "SR-22 y CDL (camioneros)", href: "/sr22-licencia-cdl" },
      { label: "SR-22 con ITIN (sin SSN)", href: "/sr22-con-itin" },
      { label: "SR-22 con licencia extranjera", href: "/sr22-licencia-extranjera" },
      { label: "SR-22 sin crédito", href: "/sr22-sin-credito-sin-down-payment" },
      { label: "Uber / Lyft / DoorDash", href: "/sr22-uber-lyft-doordash" },
      { label: "Mudanza a otro estado", href: "/sr22-mudanza-otro-estado" },
      { label: "Mudanza interestatal (cross-filing)", href: "/sr22-mudanza-interestatal" },
      { label: "🚚 SR-22 de estado anterior", href: "/sr22-cumplir-estado-anterior" },
    ],
  },
  {
    label: "Precios y Comparativas",
    emoji: "💰",
    items: [
      { label: "🧮 Calculadora de Costos SR-22", href: "/calculadora-sr22" },
      { label: "SR-22 más barato por estado", href: "/seguro-sr22-barato-por-estado" },
      { label: "Costo del seguro tras un DUI", href: "/costo-seguro-despues-dui" },
      { label: "SR-22 vs FR-44", href: "/sr22-vs-fr44" },
      { label: "Progressive vs Dairyland", href: "/progressive-vs-dairyland" },
      { label: "Comparativa final SR-22", href: "/comparativa-sr22" },
      { label: "¿Cuánto dura el SR-22?", href: "/cuanto-dura-sr22" },
      { label: "Cómo cancelar el SR-22", href: "/cancelar-sr22" },
      { label: "Remover SR-22 tras 3 años", href: "/remover-sr22" },
    ],
  },
  {
    label: "Restauración",
    emoji: "🔄",
    items: [
      { label: "Guía IID (Alcoholímetro)", href: "/guia-iid-alcoholimetro" },
      { label: "Licencia y Child Support", href: "/licencia-suspendida-child-support" },
      { label: "Limpiar antecedentes (DUI)", href: "/limpiar-antecedentes-dui" },
    ],
  },
  {
    label: "Aseguradoras",
    emoji: "⭐",
    items: [
      { label: "Reseña: The General", href: "/resena-the-general" },
      { label: "Reseña: Dairyland", href: "/resena-dairyland" },
      { label: "Reseña: Kemper / Infinity", href: "/resena-kemper" },
    ],
  },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openCategory, setOpenCategory] = useState<string | null>(null);
  const [mobileOpenCat, setMobileOpenCat] = useState<string | null>(null);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 w-full shadow-md" style={{ background: "hsl(var(--primary))" }}>
      {/* Disclaimer bar */}
      <div
        className="hidden md:flex items-center justify-center px-4 py-1 text-xs gap-2"
        style={{ background: "hsl(var(--secondary))", color: "hsl(215 20% 65%)" }}
      >
        <ExternalLink className="w-3 h-3 flex-shrink-0" />
        <span>
          Sitio informativo independiente. No somos una aseguradora ni prestamos asesoría legal.{" "}
          <Link to="/aviso-legal" className="underline hover:opacity-80">Ver aviso legal</Link>
        </span>
      </div>

      <nav className="container mx-auto flex items-center justify-between px-4 sm:px-6 py-3">
        {/* Logo */}
        <Link
          to="/"
          className="flex items-center gap-2 flex-shrink-0 group"
          onClick={() => { window.scrollTo({ top: 0, left: 0, behavior: "instant" }); }}
        >
          <div
            className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
            style={{ background: "hsl(var(--accent) / 0.15)", border: "1px solid hsl(var(--accent) / 0.3)" }}
          >
            <Shield className="w-5 h-5" style={{ color: "hsl(var(--accent))" }} />
          </div>
          <span className="font-bold text-lg md:text-xl tracking-tight" style={{ color: "hsl(var(--primary-foreground))" }}>
            SeguroSR22<span style={{ color: "hsl(var(--accent))" }}>USA</span>
          </span>
        </Link>

        {/* Tagline */}
        <div className="hidden md:flex lg:hidden flex-1 justify-center">
          <span className="text-xs font-medium tracking-wide" style={{ color: "hsl(var(--primary-foreground) / 0.7)" }}>
            Guía SR-22 en EE.UU. · Información gratuita · Sin intermediarios
          </span>
        </div>

        {/* Desktop dropdown menu */}
        <div className="hidden lg:flex items-center gap-1">
          {navCategories.map((cat) => (
            <div
              key={cat.label}
              className="relative"
              onMouseEnter={() => setOpenCategory(cat.label)}
              onMouseLeave={() => setOpenCategory(null)}
            >
              <button
                className="flex items-center gap-1 px-3 py-2 rounded-lg text-xs font-semibold transition-colors"
                style={{
                  color: "hsl(var(--primary-foreground) / 0.9)",
                  background: openCategory === cat.label ? "hsl(0 0% 100% / 0.12)" : "transparent",
                }}
              >
                <span>{cat.emoji}</span>
                <span>{cat.label}</span>
                <ChevronDown className={`w-3 h-3 transition-transform ${openCategory === cat.label ? "rotate-180" : ""}`} />
              </button>

              <div
                className="absolute top-full left-0 mt-1 rounded-xl shadow-xl border z-50 py-2 min-w-[220px] transition-all duration-150 overflow-y-auto"
                style={{
                  background: "hsl(var(--card))",
                  borderColor: "hsl(var(--border))",
                  maxHeight: "calc(100vh - 120px)",
                  opacity: openCategory === cat.label ? 1 : 0,
                  transform: openCategory === cat.label ? "translateY(0)" : "translateY(-6px)",
                  pointerEvents: openCategory === cat.label ? "auto" : "none",
                }}
              >
                {cat.items.map((item) => (
                  <Link
                    key={item.href}
                    to={item.href}
                    className="block px-4 py-2 text-xs font-medium transition-colors hover:bg-muted"
                    style={{
                      color: location.pathname === item.href ? "hsl(var(--accent))" : "hsl(var(--foreground))",
                      fontWeight: location.pathname === item.href ? "700" : undefined,
                    }}
                  >
                    {location.pathname === item.href && "→ "}{item.label}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Desktop CTA */}
        <div className="hidden lg:flex items-center gap-2">
          <Link to="/sobre-nosotros" className="text-xs font-medium px-3 py-2"
            style={{ color: "hsl(var(--primary-foreground) / 0.7)" }}>
            Nosotros
          </Link>
          <a
            href="https://www.google.com/search?q=seguro+SR-22+cerca+de+mi"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-cta px-4 py-2 text-xs whitespace-nowrap"
          >
            Buscar SR-22 <ExternalLink className="w-3 h-3" />
          </a>
        </div>

        {/* Mobile header */}
        <div className="lg:hidden flex items-center gap-2">
          <a
            href="https://www.google.com/search?q=seguro+SR-22+cerca+de+mi"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-cta px-3 py-1.5 text-xs whitespace-nowrap"
          >
            Buscar SR-22
          </a>
          <button
            className="p-2 rounded-lg transition-colors flex-shrink-0"
            style={{ color: "hsl(var(--primary-foreground))" }}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      <div
        className="lg:hidden overflow-hidden border-t transition-all duration-200"
        style={{
          borderColor: "hsl(var(--primary-light))",
          background: "hsl(var(--secondary))",
          maxHeight: mobileOpen ? "calc(100vh - 60px)" : "0",
          opacity: mobileOpen ? 1 : 0,
        }}
      >
        <div className="container mx-auto px-4 py-2 overflow-y-auto" style={{ maxHeight: "calc(100vh - 60px)" }}>
          {/* Quick links */}
          <div className="flex gap-2 py-2 border-b mb-1" style={{ borderColor: "hsl(0 0% 100% / 0.08)" }}>
            <Link to="/" className="text-xs px-3 py-1.5 rounded-lg font-medium"
              style={{ background: "hsl(0 0% 100% / 0.1)", color: "hsl(var(--primary-foreground))" }}
              onClick={() => setMobileOpen(false)}>
              🏠 Inicio
            </Link>
            <Link to="/sobre-nosotros" className="text-xs px-3 py-1.5 rounded-lg font-medium"
              style={{ background: "hsl(0 0% 100% / 0.1)", color: "hsl(var(--primary-foreground))" }}
              onClick={() => setMobileOpen(false)}>
              Nosotros
            </Link>
            <Link to="/contacto" className="text-xs px-3 py-1.5 rounded-lg font-medium"
              style={{ background: "hsl(0 0% 100% / 0.1)", color: "hsl(var(--primary-foreground))" }}
              onClick={() => setMobileOpen(false)}>
              Contacto
            </Link>
          </div>

          {/* Categories */}
          {navCategories.map((cat) => (
            <div key={cat.label} className="border-b" style={{ borderColor: "hsl(0 0% 100% / 0.06)" }}>
              <button
                className="w-full text-left px-2 py-3 flex items-center justify-between text-sm font-bold"
                style={{ color: "hsl(var(--primary-foreground))" }}
                onClick={() => setMobileOpenCat(mobileOpenCat === cat.label ? null : cat.label)}
              >
                <span>{cat.emoji} {cat.label}</span>
                <ChevronDown className={`w-4 h-4 transition-transform ${mobileOpenCat === cat.label ? "rotate-180" : ""}`} />
              </button>
              <div
                className="overflow-hidden transition-all duration-150"
                style={{
                  maxHeight: mobileOpenCat === cat.label ? `${cat.items.length * 40}px` : "0",
                  opacity: mobileOpenCat === cat.label ? 1 : 0,
                }}
              >
                <div className="pb-2">
                  {cat.items.map((item) => (
                    <Link
                      key={item.href}
                      to={item.href}
                      className="flex items-center gap-2 px-5 py-2 text-xs rounded-lg mx-1 my-0.5 transition-colors"
                      style={{
                        color: location.pathname === item.href ? "hsl(var(--accent))" : "hsl(var(--primary-foreground) / 0.8)",
                        background: location.pathname === item.href ? "hsl(0 0% 100% / 0.08)" : "transparent",
                      }}
                      onClick={() => setMobileOpen(false)}
                    >
                      <span className="w-1 h-1 rounded-full flex-shrink-0"
                        style={{ background: location.pathname === item.href ? "hsl(var(--accent))" : "hsl(0 0% 100% / 0.3)" }} />
                      {item.label}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          ))}

          <div className="px-2 pt-3 pb-4">
            <p className="text-xs" style={{ color: "hsl(215 20% 50%)" }}>
              Sitio informativo independiente. No somos aseguradora.
            </p>
          </div>
        </div>
      </div>
    </header>
  );
}
